var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopBlockWrapper"},[_c('div',{attrs:{"id":"stars"}}),_c('div',{attrs:{"id":"stars2"}}),_c('div',{attrs:{"id":"stars3"}}),_c('Header'),_c('MainSlider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }